import { useMemo, useRef } from 'react';
import { debounce } from './debounce';

export const useDebouncedFn = <TArguments extends unknown[], TResult>(fn: (...args: TArguments) => TResult, delay = 500) => {
  const fnRef = useRef(fn);
  fnRef.current = fn;
  return useMemo(() => debounce((...args: TArguments) => fnRef.current(...args), delay), [delay]);
};
